(function () {
  'use strict';

  angular
    .module('directive.page-head', [])

    /* @ngInject */
    .directive('pageTitle', ["$window", function ($window) {
      return {
        restrict: 'E',
        scope: {
          title: '@',
          checkout: '@?'
        },
        link: function (scope, element) {
          if (scope.checkout && scope.checkout === 'true') {
            $(document.body).addClass('checkout');
          } else {
            $(document.body).removeClass('checkout');
          }
          scope.$emit('pageTitle', scope.checkout && scope.checkout === 'true');
          $window.document.title = scope.title;
        }
      };
    }])

    /* @ngInject */
    .directive('pageMetaDescription', function () {
      return {
        restrict: 'E',
        scope: {
          content: '@'
        },
        link: function (scope, element) {
          $('meta[name="description"]').attr('content', scope.content);
        }
      };
    });

})();
